import React from 'react';

import { Section } from '@gogame/components';

import RecipientsField from './RecipientsField';
import { RECIPIENTS } from './constants';

const Recipients = () => {
  return (
    <Section title={'Recipients'}>
      <RecipientsField
        label={'Recipients'}
        name={RECIPIENTS}
        required={true}
        padding={0}
      />
    </Section>
  );
};

export default Recipients;
